<template>
  <div
    class="d-flex pa-2 full-width overflow-hidden flex-md-row"
    v-on="$listeners"
  >
    <v-avatar color="#F4F7FA" size="60">
      <v-img
        :src="image_url"
        :lazy-src="image_url"
        :aspect-ratio="1"
        min-width="100"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-avatar>
    <div
      class="pl-4 pb-2 pr-4 flex-grow-1 d-flex flex-column full-width overflow-hidden"
    >
      <div
        class="font-weight-bold full-width"
        :title="item.name"
        style="font-size:20px"
      >
        {{ item.name }}
      </div>
      <div class="d-flex">
        <div class="pr-0">{{ item.type }}</div>
      </div>
      <div
        class="pt-2 pb-1 d-flex align-center full-width"
        :title="item.updated_at | calcDate"
      >
        <span class="text-truncate">
          {{ $t('workspace.modified') }}
          <strong class="ng-binding">{{ item.updated_at | calcDate }}</strong>
        </span>
      </div>
      <div class="mt-auto">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { getUUIDv4 } from '@utils'
export default {
  props: {
    workspace: { type: Object, default: () => ({}) },
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: () => ({
    key: '',
  }),
  mounted() {
    this.key = getUUIDv4()
  },
  computed: {
    item() {
      return this.value
    },
    image_url() {
      return `${this.item.image_url}?key=${this.key}`
    },
  },
}
</script>

<style scoped></style>
